(ns frontend.view.components.form.components.form-textarea
  (:require
   [reagent.core :as r]
   [frontend.view.components.form.components.form-label :as form-label]
   [clojure.string :as string]
   [frontend.view.components.form.components.form-cancel-button :as cancel-button]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]))

(defn form-textarea*
  [{:keys [value intelligence-value field wrapper placeholder control-id raw-input
           has-focus
           edit? read-only? on-cancel!
           set-edit! reset-raw-input! on-key-down! validate!]
    :as   view-args}]
  [rbs/FormGroup
   {:control-id control-id
    :class-name (fu/cs wrapper "form__textarea")
    :on-click   (when (and edit? (fn? set-edit!))
                  #(set-edit! true))}
   [form-label/view
    (merge view-args
           {:intelligence-value intelligence-value})]
   [rbs/InputGroup {:style {:width "100%"}}
    [:div.form__textarea__container
     [:textarea
      {:placeholder (or placeholder "")
       :id          control-id
       :class-name  "form-control form__textarea"
       :disabled    (boolean read-only?)
       :on-focus    (fn [_]
                      (reset! has-focus true)
                      (reset-raw-input! nil))
       :on-blur     (fn [_]
                      (reset! has-focus false))
       :value       (or (if (nil? @raw-input)
                          (or value intelligence-value)
                          @raw-input)
                        "")
       :on-change   (fn [e]
                      (let [input (-> e
                                      .-target
                                      .-value)
                            safe-value (subs input
                                             0
                                             (min (count input)
                                                  10000))]
                        (reset-raw-input! safe-value)
                        (when validate! (validate! @raw-input))))
       :on-key-down on-key-down!}]
     (when @has-focus
       [cancel-button/view on-cancel!])
     [:p
      {:id         control-id
       :class-name (str "form-control-plaintext edit-off"
                        (when (:is-borderless? field) " borderless"))}
      (str (if (nil? @raw-input) (or value intelligence-value) @raw-input) " ")]]]])

(defn view
  [_]
  (let [raw-input (r/atom nil)
        has-focus (r/atom false)
        flicker-timeout (r/atom nil)
        reset-raw-input! (fn [v]
                           (when @flicker-timeout
                             (.clearTimeout js/window @flicker-timeout)
                             (reset! flicker-timeout nil))
                           (reset! raw-input v))]
    (fn
      [{:keys [value on-change! on-submit! on-cancel! intelligence-value]
        :as   view-args}]
      (let [on-cancel! (fn [e]
                         (reset-raw-input! nil)
                         (on-cancel! e))
            on-key-down! (fn [e]
                           (let [key (.-keyCode e)]
                             (when (and (= key 13) (.-ctrlKey e))
                               (-> e
                                   .-target
                                   .blur))    ;; enter
                             (when (= key 27) ;; esc cancels inline editing
                               (on-cancel! e))))
            on-submit! (if true ; empty-on-submit?
                         (fn [e]
                           (on-submit! e)
                           (reset! flicker-timeout (.setTimeout js/window
                                                                (partial reset-raw-input! nil)
                                                                2000)))
                         (on-submit!))
            on-submit! (fn [e]
                         (if (or (nil? @raw-input)
                                 (= @raw-input value))
                           (on-cancel! e)
                           (do
                             (on-change! @raw-input)
                             (on-submit! e))))]
        [rbs/Form
         {:on-submit on-submit!
          :on-blur   (fn [e]
                       (when (= "TEXTAREA"
                                (-> e
                                    .-target
                                    .-tagName
                                    str
                                    string/upper-case))
                         (on-submit! e)))}
         [form-textarea*
          (merge view-args
                 {:intelligence-value intelligence-value
                  :raw-input          raw-input
                  :on-cancel!         on-cancel!
                  :has-focus          has-focus
                  :reset-raw-input!   reset-raw-input!
                  :on-key-down!       on-key-down!})]]))))
